// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoContent_wrapper__3McpU","icon":"NoContent_icon__1FoCB","title":"NoContent_title__8t-M6","subtitle":"NoContent_subtitle__3ezyd"};